import { useMemo } from 'preact/hooks';
import { DayView } from './day-view';
import { readParams, widgetMode } from './params';
import { SingleClass } from './single-class';

export function App() {
  const params = useMemo(() => readParams(window.location.search), []);
  return widgetMode(params) === 'day' ? <DayView params={params} /> : <SingleClass params={params} />;
}
